/**
 * Updates CTA when stock id changes
 * @module modules/updateCTA
 */

import $ from 'jquery';
import getTemplateHTMLById from '../lib/get-template-html-by-id';

/**
 * Element class name
 * @type {string}
 */
export const TEMPLATE_PREFIX = 'cta-buttons';

/**
 * Prefix used on the template's id
 * @type {string}
 */
export const EL_CLASS = 'cta';

/**
 * Choose the CTA based on attributes.
 * @private
 * @param {object} data - Product data object
 * @param {object} data.chosen - Selected product size, including relevant data
 * @param {boolean} chosen.oos - Whether the chosen size is out of stock
 * @param {boolean} chosen.preorder - Whether the chosen size is preorder only
 * @param {boolean} data.allOnSale - Whether all sizes are on sale
 * @return {string} Selected Id
 */
function getId({ chosen = {}, allOnSale }) {
  const { oos, preorder, fwrdInStock } = chosen;
  if (oos && fwrdInStock) {
    return 'fwrd-in-stock';
  }
  if (oos && !fwrdInStock) {
    return allOnSale ? 'notify-me' : 'notify-me-special';
  }
  if (preorder) {
    return 'preorder-cart';
  }
  return 'add-to-bag';
}

/**
 * Default options for updateCTA
 * @prop {Function} getId - function to return the CTA id
 * @prop {Function} getTemplate - function to return the template
 */
const DEFAULT_OPTIONS = {
  getId,
  getTemplate: getTemplateHTMLById,
};

/**
 * Update CTA based on selected value.
 * @param {object} data - Product data object
 * @param {HTMLElement} data.wrap - The .product wrap
 * @param {string} data.wrapBlockClass - Class of wrap HTML Element
 * @param {boolean} data.allOnSale - Whether all sizes are on sale
 * @see DEFAULT_OPTIONS
 * @return {jQuery} Updated element
 */
export default function updateCTA(data, options = {}) {
  const { wrap, wrapBlockClass } = data;
  const {
    getId: getIdFunc,
    getTemplate: getTemplateFunc,
  } = $.extend({}, DEFAULT_OPTIONS, options);

  // find the element
  const $el = $(wrap).find(`.${wrapBlockClass}__${EL_CLASS}:not([data-type="subscription"]):not([data-type="bobs-watches"])`);
  if (!$el.length) {
    return false;
    // throw new Error(`Element not found: .${wrapBlockClass}__${EL_CLASS}`);
  }

  // get the proper html
  const id = getIdFunc(data);
  const html = id ? getTemplateFunc(`${TEMPLATE_PREFIX}.${id}`) : '';

  // update the element
  $el.html(html);
  return $el;
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-cta-update.js